/**
 * @file The one rule for which `/runlanguagemodel` task failures the user
 * sees: a refusal (an HTTP 4xx, carried as `status` on the thrown error by
 * `callRunLanguageModel`). A timeout, gateway or network failure is not shown,
 * because the task may still be running and its job document is the truth.
 * Consumers: `usePageRetry` and the `startPdfIntake` service.
 */

/** True for a `/runlanguagemodel` task error that is a refusal (an HTTP 4xx), the only kind shown to the user; a timeout, gateway or network failure leaves the job document as the truth. */
export function isTaskRefusal(error: unknown): boolean {
  return (
    error instanceof Error &&
    'status' in error &&
    typeof error.status === 'number' &&
    error.status >= 400 &&
    error.status < 500
  );
}
